import "./Header.css";
import ViewNotification from "./ViewNotification";
import UserInformation from "./UserInformation";
import { useAuth } from "../../contexts/AuthContext";
import { NavLink, useParams } from "react-router-dom";
import { useEffect } from "react";
import ForceReloadButton from "../../components/Buttons/ForceReloadButton";

const Header = (props) => {
  const { menu, setMenu } = props;
  return (
    <div className="h-[110px] flex flex-col justify-between bg-[#618BCC] sm:bg-gradient-to-r from-[#618BCC] to-[#0B3C5D]">
      <div className="flex justify-between">
        <button
          onClick={() => setMenu(!menu)}
          className="hidden text-2xl px-4 portrait:block"
        >
          <i className="fas fa-angle-double-right"></i>
        </button>
        <div className=""></div>
        <div className="flex justify-between items-center gap-2 px-4 pt-2">
          <ForceReloadButton />
          <ViewNotification />
          <UserInformation />
        </div>
      </div>
      <TabsContainer menu={menu} />
    </div>
  );
};

const TabsContainer = ({ menu }) => {
  const { user, setUser } = useAuth();
  const { rolId } = useParams();
  useEffect(() => {
    setUser(user);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={`w-full ${!menu ? 'lg:w-[calc(100vw-230px)]' : 'lg:w-[calc(100vw-60px)]'}`}>
      <nav className="flex overflow-auto">
        {user?.rols?.map((rol) => {
          const isActive = parseInt(rolId) === rol.id;
          return (
            <NavLink
              to={`/rol/${rol.id}/menu`}
              key={rol.id}
              className={`
                p-2 pb-3 flex w-full gap-1 items-center cursor-pointer font-semibold drop-shadow-md duration-200 justify-center
                ${isActive
                  ? "bg-white rounded-t-[15px] text-[#143f5f]"
                  : "bg-[#2F527B] shadow-[0_0_10px_rgba(0,0,0,0.25)] rounded-t-[15px] text-white"
                }
                `}
            >
              <i
                // icon={`${rol.icon ? rol.icon : "fa-solid fa-user-pen"}`}
                className={`fa-solid fa-street-view text-[20px]`}
              />
              <span className="whitespace-nowrap text-lg">{rol.label}</span>
            </NavLink>
          );
        })}
      </nav>
    </div>
  );
};

export default Header;
